module.exports = __webpack_public_path__ + "img/add_member_icon.51d86961.svg";